import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBookmarkedPosts } from '../services/api';
import { useNotification } from '../context/NotificationContext';
import Post from '../components/Post';
import './Feed.css';

function Saved() {
  const { showError } = useNotification();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await getBookmarkedPosts(50, 0);
      setPosts(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Error loading saved posts:', err);
      showError('Failed to load saved posts.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // showError is stable from NotificationContext — exclude to avoid re-fetching on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="feed-layout">
      <div className="feed-sidebar-left">
        <div className="brand-card">
          <div className="brand-card-content">
            <p className="brand-card-slogan">
              Saved.
              <br />
              For Later.
            </p>
          </div>
          <div className="brand-card-accent"></div>
        </div>
      </div>

      <div className="feed-main">
        <div className="posts-list">
          {loading ? (
            <div className="empty-state">
              <p>Loading saved posts…</p>
            </div>
          ) : posts.length === 0 ? (
            <div className="empty-state saved-empty-state">
              <h3>Nothing saved yet</h3>
              <p>Tap the bookmark icon on any post to save it for later.</p>
              <Link to="/feed" className="saved-empty-cta">
                Browse Feed
              </Link>
            </div>
          ) : (
            posts.map((post) => (
              <div key={post.id} id={`post-${post.id}`}>
                <Post post={post} onDelete={load} onUpdate={load} />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default Saved;
